<template>
    <div>
      <router-view></router-view>
    </div>
  </template>
  
  <script>
  export default {
    name: 'Promotion',
    computed: {
      activeTab() {
        return this.$route.path.split('/').pop();
      }
    },
    methods: {
      handleTabChange(index) {
        this.$router.push({ path: `/home/lottery-management/${index}` });
      }
    }
  };
  </script>
  
  <style scoped>
  .el-menu {
    margin-bottom: 20px;
  }
  </style>